import './App.scss';
import { AdobeAnalyticsProvider } from '../../providers/AdobeAnalytics';
import {
  EventType,
  InteractionRequiredAuthError,
  InteractionType
} from '@azure/msal-browser';
import {
  MsalAuthenticationTemplate,
  useIsAuthenticated,
  useMsal
} from '@azure/msal-react';
import { ALLLANGS, REQUIREDROLES } from './constants';
import { Route, Routes, useLocation } from 'react-router-dom';
import { SkipLinkProvider } from '../../providers/SkipLinkProvider';
import { sllrProfAxios } from '../../pages/SellerProfile/APIs/axiosDefault';
import Api from '../../pages/Api/Api';
import AppFooter from '../../components/AppFooter/AppFooter';
import AppHeader from '../../components/AppHeader/AppHeader';
import AppLoader from '../../components/AppLoader/AppLoader';
import AppPwdLogin from '../../components/AppPwdLogin/AppPwdLogin';
import AppSkipLink from '../../components/AppSkipLink/AppSkipLink';
import axios from 'axios';
import Benefits from '../Discover/Benefits/Benefits';
import ConnectionOptions from '../Discover/ConnectionOptions/ConnectionOptions';
import CssBaseline from '@mui/material/CssBaseline';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import FaqSection from '../../pages/Support/FaqSection/FaqSection';
import FourOfour from '../../pages/404/404';
import Home from '../../pages/Discover/Home';
import KnownIssues from '../../pages/Support/KnownIssues/KnownIssues';
import NdcCapabilities from '../Discover/NdcCapabilities/NdcCapabilities';
import React, { useEffect, useState, createContext } from 'react';
// import Registration from '../Registration/Registration';
import Roadmap from './RoadmapRedirect';
import SellerProfile from '../SellerProfile/SellerProfile';
import SellerRegStarting from '../../pages/SellerRegistration/SellerRegStarting';
import StatusPage from '../../pages/Support/StatusPage/StatusPage';
import SubsellerSignUp from '../SubSeller/SubsellerSignUp';
import Support from '../../pages/Support/Support';
import { useTranslation } from 'react-i18next';
import NotificationPreferences from '../Discover/NotificationPreferences';
import BackOfficeConfigurationForm from '../../components/BackOfficeConfigurationForm';
import i18next from 'i18next';
import { theme } from '../../theme/theme';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import Microsite from '../Microsite';
import SellerRegistrationTest from '../SellerRegistration/SellerRegistration';

export interface iLangContext {
  otherReadableLanguage: string;
  readableLanguage: string;
  selectedLanguage: string;
  setSelectedLanguage: any;
}

export const LangContext = createContext<iLangContext>({
  otherReadableLanguage: '',
  readableLanguage: '',
  selectedLanguage: '',
  setSelectedLanguage: (selectedLanguage: string) => {}
});

axios.defaults.headers.common['x-api-key'] =
  process.env.REACT_APP_SELLER_PROFILE_API_KEY;

const App = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [userName, setUserName] = useState('');
  const [headerHeight, setHeaderHeight] = useState(0);
  const [logoHeight, setLogoHeight] = useState(0);
  const [announcementBanner, setAnnouncementBanner] = useState(false);
  const [isFooterNavigation, setIsFooterNavigation] = useState(false);
  const [isStatusAPILoading, setIsStatusAPILoading] = useState(false);

  useEffect(() => {}, [headerHeight]);

  useEffect(() => {
    const hideElementsFromScreenReaders = () => {
      const elements = document.querySelectorAll('img, hr');
      elements.forEach((el) => {
        el.setAttribute('aria-hidden', 'true');
      });
    };
    hideElementsFromScreenReaders();

    const observer = new MutationObserver(() => {
      hideElementsFromScreenReaders();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  //AZURE

  const { instance } = useMsal();

  window.instance = instance;

  const isAuthenticated = useIsAuthenticated();

  const userRolesRef = React.useRef<string[]>([]);
  const onSellerProfile = location.pathname.includes('/seller-profile');
  const [isAuth, setIsAuth] = useState(!onSellerProfile);
  const [coName, setCoName] = useState(localStorage.getItem('coName') || '');

  const doSetUserName = (name) => {
    if (userName === '' && name !== '' && name !== null) {
      const firstName = name?.split(' ')[0];
      const lastInitial = name?.charAt(name.lastIndexOf(' ') + 1);
      setUserName(`${firstName} ${lastInitial}.`);
    }
  };
  React.useEffect(() => {
    if (!isAuthenticated) {
      instance
        /* @ts-ignore */
        .ssoSilent() //@ts-ignore
        .then((res) => {
          instance.setActiveAccount(res.account);
        })
        .catch((err) => {
          if (err instanceof InteractionRequiredAuthError) {
            instance.loginRedirect();
          }
        });
    }

    const id: any = instance.addEventCallback((event) => {
      instance.getActiveAccount()?.name &&
        doSetUserName(instance.getActiveAccount()?.name);

      if (
        event.eventType === EventType.LOGIN_SUCCESS ||
        event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
        event.eventType === EventType.SSO_SILENT_SUCCESS
      ) {
        instance.setActiveAccount(event.payload.account);
        userRolesRef.current = event.payload.idTokenClaims.roles;

        // const isAdmin = userRolesRef.current.some((role) =>
        //   role.includes('Admin')
        // );
        // dispatch(setIsAdmin(isAdmin));

        if (
          !event.payload.idTokenClaims?.roles?.some((role) =>
            REQUIREDROLES.includes(role)
          )
        ) {
          // if (window.location.pathname !== "/page-not-found") {
          //   window.location.href = "/page-not-found";
          // }
        }

        sllrProfAxios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${event.payload.idToken}`;

        sllrProfAxios.defaults.headers.common['x-api-key'] =
          process.env.REACT_APP_SELLER_PROFILE_API_KEY;
        sllrProfAxios.defaults.headers.common['Content-Type'] =
          'application/json';

        setIsAuth(true);
        doSetUserName(event.payload?.account?.name);
      }
    });

    return () => instance.removeEventCallback(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logoutAzure = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href =
      'https://login.microsoftonline.com/common/oauth2/logout'; //bypases bug of instance.logout forcing you to choose which account to logout
    // instance.logout();
  };
  //END AZURE

  let defaultLang = 'en';
  if (window.location.href.includes('/fr/')) {
    localStorage.setItem('selectedLanguage', 'fr');
    defaultLang = 'fr';
  }
  const path = window.location.pathname;
  if (
    (path.includes('/roadmap') ||
      path.includes('/feuillederoute') ||
      path.includes('/supportedmarkets')) &&
    !path.includes('/api/')
  ) {
    //vanity url for ndc.aircanada.ca/roadmap or ndc.aircanada.ca/feuillederoute
    if (path.includes('/fr/') || path.includes('/feuillederoute')) {
      window.location.href = `/fr/api/roadmap`;
    } else {
      window.location.href = `/en/api/roadmap`;
    }
  } else if (!path.includes('/en/') && !path.includes('/fr/')) {
    if (localStorage.getItem('selectedLanguage')) {
      window.location.href = `/${localStorage.getItem(
        'selectedLanguage'
      )}${path}`;
    } else {
      window.location.href = `/en${path}`;
    }
  }

  const [selectedLanguage, setSelectedLanguage] = useState<string>(defaultLang);
  const [readableLanguage, setReadableLanguage] = useState<string>(
    defaultLang === 'fr' ? 'Français' : 'English'
  );
  const [otherReadableLanguage, setOtherReadableLanguage] = useState<string>(
    defaultLang === 'fr' ? 'English' : 'Français'
  );

  const { i18n } = useTranslation();

  const getVersion = async () => await axios.get(`${jsonEnvUrl}/version.json`);

  const getStoredVersion = () => sessionStorage.getItem('version') || '';

  const getVersionData = (vers) => {
    console.log('Getting Data for Version:', vers);
    const fetchCalls = [axios.get(`/json/drupal-en.json`)]; //Always need to get Eng JSON even on Fr, b/c some content not translated
    const dataFetch = async () => await Promise.all(fetchCalls);
    if (vers === getStoredVersion() || sessionStorage.getItem('jsonData')) {
      fetchCalls.slice(0); //don't need to get Eng JSON again
    }
    if (defaultLang === 'fr') {
      fetchCalls.push(axios.get(`/json/drupal-fr.json`));
    }

    sessionStorage.setItem(`version`, vers);
    dataFetch()
      .then((resp) => {
        let mergedData = resp[0].data;
        resp.forEach((r) => (mergedData = { ...mergedData, ...r.data }));
        sessionStorage.setItem(`jsonData`, JSON.stringify(mergedData));
        setLoading(false);
      })
      .catch((err) => {
        console.log('Error getting data:', err);
      });
  };
  const getData = () => {
    getVersion()
      .then((resp) => {
        return resp.data.version;
      })
      .then((vers) => {
        getVersionData(vers);
      })
      .catch((err) => {
        process.env.REACT_APP_ENV_LOADED === 'DEV' &&
          getVersionData('1707251514'); // FOR TESTING ON ONLY...  (port != 3000)
      });
  };

  React.useEffect(() => {
    // set defaults
    console.log('Fetching Data:', defaultLang, isAuth);
    onSellerProfile && isAuth === true && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuth]);

  useEffect(() => {
    setReadableLanguage(selectedLanguage === 'fr' ? 'Français' : 'English');
    setOtherReadableLanguage(
      selectedLanguage === 'fr' ? 'English' : 'Français'
    );
    localStorage.setItem('selectedLanguage', selectedLanguage);
    isAuth === true && getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLanguage]);

  useEffect(() => {
    const language = location.pathname.split('/')[1];
    if (ALLLANGS.includes(language.toLowerCase())) {
      i18n.changeLanguage(language);
    }
  }, [location, i18n]);

  const env = process.env.REACT_APP_ENV_LOADED;
  const jsonEnvExt = env === 'PROD' ? '' : env === 'BAT' ? '-bat' : '-int';
  const jsonEnvUrl = `https://content-ndc-portal${jsonEnvExt}.aircanada.com/content`;

  const [UATpwd, setUATpwd] = useState('');
  const [displayError, setDisplayError] = useState('');

  //if UAT, require pwd
  useEffect(() => {
    if (
      process.env.REACT_APP_UAT_PWD &&
      UATpwd === process.env.REACT_APP_UAT_PWD
    ) {
      localStorage.setItem('uatPWD', UATpwd);
    } else if (UATpwd !== '') {
      setDisplayError('incorrect');
    }
  }, [UATpwd]);

  if (
    env === 'BAT' &&
    process.env.REACT_APP_UAT_PWD &&
    UATpwd !== process.env.REACT_APP_UAT_PWD &&
    localStorage.getItem('uatPWD') !== process.env.REACT_APP_UAT_PWD
  ) {
    return <AppPwdLogin setUATpwd={setUATpwd} displayError={displayError} />;
  }

  const allData: any =
    i18next.store.data?.[i18next.language]?.translation || {};

  const siteContent = (
    <ThemeProvider theme={theme}>
      <CssBaseline>
        <LangContext.Provider
          value={{
            selectedLanguage,
            setSelectedLanguage,
            readableLanguage,
            otherReadableLanguage
          }}
        >
          <AdobeAnalyticsProvider>
            <SkipLinkProvider>
              <AppSkipLink />

              <div className="App, c-full-page">
                <AppHeader
                  // data={data}
                  selectedLanguage={selectedLanguage}
                  setSelectedLanguage={setSelectedLanguage}
                  userName={userName}
                  coName={coName}
                  logout={logoutAzure}
                  setHeaderHeight={setHeaderHeight}
                  setLogoHeight={setLogoHeight}
                  setAnnouncementBanner={setAnnouncementBanner}
                />
                {allData === '' || loading ? (
                  <AppLoader />
                ) : (
                  <div
                    className="inline-header-height"
                    style={{ marginTop: `${headerHeight}px` }}
                  >
                    <ErrorBoundary>
                      <Routes>
                        <Route path="/:urlLang/*" element={<FourOfour />} />
                        <Route
                          path="/:urlLang/"
                          element={<Home logoHeight={logoHeight} />}
                        />
                        {/* <Route
                        path="/:urlLang/agencyform"
                        element={
                          <Registration data={data['ndc-program.agencyForm']} />
                        }
                      /> */}
                        <Route
                          path="/:urlLang/ndc-program/home"
                          element={<Home logoHeight={logoHeight} />}
                        />
                        <Route path="/:urlLang/support" element={<Support />} />
                        <Route
                          path="/:urlLang/seller-registration"
                          element={<SellerRegStarting />}
                        />
                        <Route
                          path="/:urlLang/seller-registration-form"
                          element={<SellerRegistrationTest />}
                        />
                        <Route
                          path="/:urlLang/subseller-registration-form/084af2d8-e1f8-47c3-b4de-f5e0ec0e0414"
                          element={<SubsellerSignUp />}
                        />
                        <Route
                          path="/:urlLang/events/a4ed4281-7e9f-4e48-bd58-2032e664c09c"
                          element={<Microsite logoHeight={logoHeight} />}
                        />
                        <Route
                          path="/:urlLang/seller-profile"
                          element={
                            <SellerProfile
                              coName={coName}
                              setCoName={setCoName}
                              logoHeight={logoHeight}
                            />
                          }
                        />
                        <Route
                          path="/:urlLang/seller-profile/:section"
                          element={
                            <SellerProfile
                              coName={coName}
                              setCoName={setCoName}
                              logoHeight={logoHeight}
                            />
                          }
                        />

                        <Route
                          path="/:urlLang/support/faq"
                          element={
                            <FaqSection
                              announcementBanner={announcementBanner}
                              // communicationBanner={communicationBanner}
                              logoHeight={logoHeight}
                              // bannerHeight={bannerHeight}
                            />
                          }
                        />

                        <Route
                          path="/:urlLang/test"
                          element={
                            <SellerRegistrationTest />
                          }
                        />
                        <Route
                          path="/:urlLang/support/faq/:type"
                          element={
                            <FaqSection
                              announcementBanner={announcementBanner}
                              // communicationBanner={communicationBanner}
                              logoHeight={logoHeight}
                              // bannerHeight={bannerHeight}
                            />
                          }
                        />
                        {/* <Route
                        path="/:urlLang/support/faq/technical"
                        element={<FaqSection data={data} showTab={1} />}
                      /> */}
                        <Route
                          path="/:urlLang/support/knownIssues"
                          element={<KnownIssues />}
                        />
                        <Route
                          path="/:urlLang/support/statusMonitoring"
                          element={
                            <StatusPage
                              setIsStatusAPILoading={setIsStatusAPILoading}
                            />
                          }
                        />
                        <Route
                          path="/:urlLang/support/statusMonitoring/PROD"
                          element={
                            <StatusPage
                              setIsStatusAPILoading={setIsStatusAPILoading}
                            />
                          }
                        />
                        <Route
                          path="/:urlLang/support/statusMonitoring/GOLD"
                          element={
                            <StatusPage
                              setIsStatusAPILoading={setIsStatusAPILoading}
                            />
                          }
                        />
                        <Route
                          path="/:urlLang/support/statusMonitoring/BAT"
                          element={
                            <StatusPage
                              setIsStatusAPILoading={setIsStatusAPILoading}
                            />
                          }
                        />

                        <Route path="/:urlLang/support" element={<Support />} />

                        <Route
                          path="/:urlLang/support/knownIssues"
                          element={<KnownIssues />}
                        />
                        <Route path="/:urlLang/roadmap" element={<Roadmap />} />
                        <Route
                          path="/:urlLang/feuillederoute"
                          element={<Roadmap />}
                        />
                        <Route
                          path="/:urlLang/api/*"
                          element={
                            <Api
                              logoHeight={logoHeight}
                              announcementBanner={announcementBanner}
                              isFooterNavigation={isFooterNavigation}
                            />
                          }
                        />

                        <Route
                          path="/:urlLang/ndc-program/benefits"
                          element={<Benefits />}
                        />
                        <Route
                          path="/:urlLang/ndc-program/connection-options"
                          element={<ConnectionOptions showTab={0} />}
                        />
                        <Route
                          path="/:urlLang/ndc-program/connection-options/direct-integration"
                          element={<ConnectionOptions showTab={0} />}
                        />
                        <Route
                          path="/:urlLang/ndc-program/connection-options/technology-partners"
                          element={<ConnectionOptions showTab={1} />}
                        />
                        <Route
                          path="/:urlLang/ndc-program/connection-options/ac-connex"
                          element={<ConnectionOptions showTab={2} />}
                        />
                        <Route
                          path="/:urlLang/ndc-program/ndc-capabilities"
                          element={<NdcCapabilities showTab={0} />}
                        />
                        <Route
                          path="/:urlLang/ndc-program/ndc-capabilities/detailed-comparison"
                          element={<NdcCapabilities showTab={0} />}
                        />
                        <Route
                          path="/:urlLang/notifications-preferences"
                          element={
                            <NotificationPreferences
                              logoHeight={logoHeight}
                              announcementBanner={announcementBanner}
                            />
                          }
                        />
                        <Route
                          path="/:urlLang/backoffice-form/097af2d8-s133-47c3-b4de-f5e0ec0"
                          element={<BackOfficeConfigurationForm />}
                        />
                      </Routes>
                    </ErrorBoundary>
                  </div>
                )}
              </div>
              <AppFooter
                isFooterNavigation={isFooterNavigation}
                setIsFooterNavigation={setIsFooterNavigation}
                isStatusAPILoading={isStatusAPILoading}
              />
            </SkipLinkProvider>
          </AdobeAnalyticsProvider>
        </LangContext.Provider>
      </CssBaseline>
    </ThemeProvider>
  );
  return window.location.href.includes('/fr/') ||
    window.location.href.includes('/en/') ? (
    onSellerProfile ? (
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={{
          redirectStartPage: location.pathname + location.search,
          scopes: ['openid', 'profile', 'email'],
          redirectUri: `/seller-profile/auth`,
          loginHint: instance.getActiveAccount()?.username
        }}
      >
        <>{siteContent}</>
      </MsalAuthenticationTemplate>
    ) : (
      <>{siteContent}</>
    )
  ) : (
    <></>
  );
};

export default App;
